// @flow

import React from 'react';
import bemify from 'bemify-js';
import { lifecycle } from 'recompose';

import AuthsList from 'app/dashboard/components/AuthsList';
import Button from 'app/common/components/Button';
import ButtonGroup from 'app/common/components/ButtonGroup';
import Link from 'app/common/components/Link';
import InfoBlock, {
  InfoBlockContent,
  InfoBlockFooter,
} from 'app/common/components/InfoBlock';
import { Heading3, HeadingIcon } from 'app/common/components/Heading';
import 'app/dashboard/components/SharedAuthsWarning.scss';

import type { Auth } from 'app/dashboard/components/AuthsList';

const bem = bemify('shared-auths-warning');

type SharedAuthsWarningProps = {
  title: string,
  description: string,
  ctaText: string,
  privateAuths: Array<Auth>,
  onCancel: () => void,
  onConfirmWarning: () => void,
};

const SharedAuthsWarning = (props: SharedAuthsWarningProps) => (
  <InfoBlock className={bem()} kind="bare">
    <InfoBlockContent>
      <Heading3 kind="flex 16 bold deepspace 1-em-bottom">
        <HeadingIcon kind="before" tagKind="is-warning" type="alert" />
        {props.title}
      </Heading3>
      <p>
        {props.description}{' '}
        <Link
          href="/help/manage/collaborate/data-privacy-in-zapier-for-teams-accounts"
          kind="unbreakable"
        >
          Learn more
        </Link>
      </p>
      <AuthsList auths={props.privateAuths} className={bem('__auths-list')} />
    </InfoBlockContent>
    <InfoBlockFooter>
      <ButtonGroup kind="block horizontal flex-buttons">
        <Button kind="secondary large block" onClick={props.onCancel}>
          Cancel
        </Button>
        <Button kind="primary large block" onClick={props.onConfirmWarning}>
          {props.ctaText}
        </Button>
      </ButtonGroup>
    </InfoBlockFooter>
  </InfoBlock>
);

const enhance = lifecycle({
  UNSAFE_componentWillMount() {
    const { props } = this;
    // If there aren't any `privateAuths` then there's nothing to
    // confirm so we can automatically confirm. Typically this will
    // result in the component unmounting itself.
    if (props.privateAuths.length === 0) {
      props.onConfirmWarning();
    }
  },
});

export default enhance(SharedAuthsWarning);
